import { FxmsData } from "../../fxms/datas/FxData";

export class FemsData extends FxmsData {

  static inited = false;

  static initData(callback) {

    if (FemsData.inited) {
      callback({});
      return;
    }

    super.initData(function (obj) {

      FxmsData.selectBoxDatas.initData("facility", "fems/facility", "facNo", "facName", "get", {}, false);

      FxmsData.selectBoxDatas.initData("energy", "fems/code/energy", "engId", "engName", "get", {}, true, function (datas) {
        if (obj) {
          obj.energy = datas;
        } else {
          obj = { energy: datas };
        }

        callback(obj);

        console.log("*** FemsData initData ***");


      });

    });

    FemsData.inited = true;
  }

}

